export enum AuthEvent {
  SignIn = "signIn",
  SignOut = "signOut",
  SignInFailure = "signIn_failure",
  CognitoHostedUIFailure = "cognitoHostedUI_failure",
}
